<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-title></ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding></ion-content>
  </div>
</template>

<script>
import axios from "axios";
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import User from "../models/User";
export default {
  name: "splash-screen",
  mixins: [Helpers, Plugins],
  computed: {
    user() {
      return this.$store.getters.getUser();
    }
  },
  data() {
    return {};
  },
  created() {
    this.hideSplashScreen();
    this.showStatusBar();
  },
  async mounted() {
    let device = (await this.deviceInfo()) || {};
    if (this.user && this.user.email) {
      this.showRootPage("forms");
    } else if (device.platform === "ios") {
      this.showRootPage("login");
    } else if (device.platform === "android") {
      this.showRootPage("login");
    } else {
      this.showRootPage("home");
    }
  }
};
</script>

<style scoped>
</style>